/* Package JSON Import will be here */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    withRouter
} from 'react-router-dom';
/* Package JSON Import will be here */

/* Project Import will be here */
import AttachmentViewerComponent from './attachmentViewer.Component';
/* Const,Let & Var will be here */
/* Const,Let & Var will be here */

class AttachmentViewer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            attachmentName: props.attachmentName ? props.attachmentName : "",
            attachmentContent: props.attachmentContent ? props.attachmentContent : "",
            isModalVisible: false
        };
    }

    componentWillMount() {
        this.openModal();
    }

    closeModal() {
        this.setState({
            isModalVisible: false
        }, function () {
            this.props.closeAttachmentViewer();
        });
    }

    openModal() {
        this.setState({
            isModalVisible: true,
        });
    }

    render() {
        const { isModalVisible, attachmentContent, attachmentName } = this.state;
        return (
            <Fragment>
                <AttachmentViewerComponent
                    {...{
                        attachmentViewer: {
                            isModalVisible,
                            attachmentContent,
                            attachmentName
                        }
                    }}
                    closeModal={this.closeModal.bind(this)}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user
    };
}

export default withRouter(connect(mapStateToProps)(AttachmentViewer));

AttachmentViewer.displayName = 'AttachmentViewer';